import React from 'react'

export default class Score extends React.Component {

  render() {
    // NB score can be unset (== null)
    let className = 'score'
    let score = ''

    if (this.props.score !== null) {
      score = this.props.score / 10
      className += score >= 0 ? ' positive' : ' negative'

      if (score < -3) {
        score = -3
        className += ' smaller-than'
      } else if( score > 3) {
        score = 3
        className += ' greater-than'
      }
    }

    return (
      <span className={className}>{score}</span>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Score.js